var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9167 0C5.78021 0 0 5.78021 0 12.9167C0 20.0531 5.78021 25.8333 12.9167 25.8333C20.0531 25.8333 25.8333 20.0531 25.8333 12.9167C25.8333 5.78021 20.0531 0 12.9167 0ZM12.9167 23.25C7.22042 23.25 2.58333 18.6129 2.58333 12.9167C2.58333 7.22042 7.22042 2.58333 12.9167 2.58333C18.6129 2.58333 23.25 7.22042 23.25 12.9167C23.25 18.6129 18.6129 23.25 12.9167 23.25Z",
    fill: "#272D45"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 11,
    width: 3,
    height: 8,
    rx: 1,
    fill: "#272D45"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 6,
    width: 3,
    height: 3,
    rx: 1,
    fill: "#272D45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.e33f34725c826d66b7cc6e85ab410bd2.svg";
export { ForwardRef as ReactComponent };